import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import useStore from '../../store/useStore';
import { Actions } from '../../interfaces/global';

const CreatePermission = () => {
  const { t } = useTranslation();
  const { setUi } = useStore();

  const handleClick = () => {
    setUi({ showModalPermission: true, action: Actions.Create });
  };

  return (
    <Button type="primary" onClick={handleClick}>
      <>{t('placeholders.createPermission')}</>
    </Button>
  );
};

export default CreatePermission;
